import { css } from 'styled-components';

import { palettes, tokens } from '../../theme/tokens';

export const PRESSED_INSET = 'inset 0 2px 2px rgba(26, 9, 44, 0.1)';

const buttonShadow = css`
	box-shadow: ${tokens.shadow.button};
`;

const pressedShadow = css`
	box-shadow: ${PRESSED_INSET}, ${tokens.shadow.button};
`;

export const Primary = css`
	background: ${tokens.text.primary};
	border: 1px solid transparent;
	color: ${tokens.text.inverse};
	${buttonShadow}

	&:hover,
	&[data-preview='hover'] {
		background: ${palettes.heatherGray['800']};
	}

	&:active,
	&[data-preview='pressed'] {
		background: ${tokens.text.primary};
		${pressedShadow}
	}
`;

export const Secondary = css`
	background: ${tokens.surface.white};
	border: 1px solid ${tokens.border.default};
	color: ${tokens.text.primary};
	box-sizing: border-box;
	${buttonShadow}

	&:hover,
	&[data-preview='hover'] {
		background: ${tokens.surface.primary};
		border-color: ${tokens.border.default};
	}

	&:active,
	&[data-preview='pressed'] {
		background: ${tokens.surface.secondary};
		border-color: ${tokens.border.default};
		${pressedShadow}
	}
`;

export const Ghost = css`
	background: transparent;
	border: 1px solid transparent;
	color: ${tokens.text.primary};
	box-sizing: border-box;

	&:hover,
	&[data-preview='hover'] {
		background: ${tokens.surface.primary};
		border-color: ${tokens.border.default};
		${buttonShadow}
	}

	&:active,
	&[data-preview='pressed'] {
		background: ${tokens.surface.secondary};
		border-color: ${tokens.border.default};
		${pressedShadow}
	}
`;

export const Destructive = css<{ $loading?: boolean; success?: boolean }>`
	background: transparent;
	border: 1px solid ${tokens.error.border};
	color: ${tokens.error.text};
	box-sizing: border-box;

	&:hover,
	&[data-preview='hover'] {
		background: ${tokens.error.background};
		border-color: ${tokens.error.border};
		${buttonShadow}
	}

	&:active,
	&[data-preview='pressed'] {
		background: ${tokens.error.icon};
		border-color: ${tokens.error.icon};
		color: ${tokens.text.inverse};
		${pressedShadow}
	}
`;

export const DisabledPrimary = css`
	background: ${palettes.heatherGray['100']};
	border: 1px solid ${palettes.heatherGray['200']};
	color: ${tokens.text.disabled};
	cursor: default;
	${buttonShadow}
`;

export const DisabledSecondary = css`
	background: ${tokens.surface.white};
	border: 1px solid ${palettes.heatherGray['200']};
	color: ${tokens.text.disabled};
	cursor: default;
	${buttonShadow}
`;

export const DisabledGhost = css`
	background: transparent;
	border: 1px solid transparent;
	box-shadow: none;
	color: ${tokens.text.disabled};
	cursor: default;
`;

export const DisabledDestructive = css`
	background: transparent;
	border: 1px solid transparent;
	box-shadow: none;
	color: ${palettes.coralRed['200']};
	cursor: default;
`;

export const InlineTextButton = css`
	text-decoration: underline;
	padding: 0;
	display: inline-block;
	color: ${tokens.text.primary};

	&:hover {
		opacity: 0.7;
	}
`;

export const AIButton = css`
	background: ${tokens.surface.white};
	border: 1px solid ${tokens.brand.border};
	color: ${tokens.brand.text};
	box-sizing: border-box;
	${buttonShadow}

	&:hover,
	&[data-preview='hover'] {
		background: ${tokens.brand.background};
		border-color: ${tokens.brand.border};
	}

	&:active,
	&[data-preview='pressed'] {
		background: ${tokens.brand.hover};
		border-color: ${tokens.brand.border};
		${pressedShadow}
	}
`;

export const DisabledAI = css`
	background: ${tokens.surface.white};
	border: 1px solid ${palettes.vividPink['200']};
	color: ${tokens.text.disabled};
	cursor: default;
	${buttonShadow}
`;
